import { createSlice } from "@reduxjs/toolkit";
import { SpecialOffersAPI } from "../../services/special-offers";

const SpecialOffers = createSlice({
  name: "Special offers",
  initialState: {
    specialOffers: [],
    oneSpecialOffer: null,
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(SpecialOffersAPI.getAll.fulfilled, (state, action) => {
        const { total, special_offers } = action.payload;

        state.specialOffers = special_offers;
        state.total = total;
      })

      .addCase(SpecialOffersAPI.getOne.fulfilled, (state, action) => {
        state.oneSpecialOffer = action.payload;
      });
  },
});

export default SpecialOffers;
